module.exports = __webpack_public_path__ + "static/media/15_alles_richtig.386d31fb.jpg";